export const tagTransfersReport = {
	title: "Vínculos do cartão",
	descriptionPlace:
		"Lista de todas as transferências de vínculos dos cartões de consumação do período.",
	descriptionEvent: "Lista de todas as transferências do evento",
	filters: {
		zigCodePlaceholder: "Filtrar por Zig Code",
		zigCodeInvalid: "Zig code inválido",
		documentPlaceholder: "Filtrar por documento do cliente",
		employeePlaceholder: "Filtrar por colaborador",
	},
	table: {
		date: "Data e hora",
		zigCode: "Zig Code",
		oldUserDocument: "Documento anterior",
		oldUser: "Cliente anterior",
		oldUserTooltip:
			"Último cliente registrado no cartão. Se o cartão foi reutilizado sem ser desvinculado, o dado exibido pode não pertencer a um cliente que está frequentando o evento atual ou local/organização",
		newUserDocument: "Documento novo",
		newUser: "Cliente novo",
		employeeName: "Operador",
		eventName: "Evento",
		openAccountFromLastUser:
			"Essa ação sobrescreveu a conta em aberto do cliente anterior.",
	},
};
